import { c as _defineProperty } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { s as styles } from '../_grid-057c99b7.js';

var gridColBem = Bem('col', styles);
var GridCol = function GridCol(_ref) {
  var _gridColBem$mix;

  var children = _ref.children,
      size = _ref.size,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xl = _ref.xl,
      push = _ref.push,
      pushSm = _ref.pushSm,
      pushMd = _ref.pushMd,
      pushLg = _ref.pushLg,
      pushXl = _ref.pushXl;
  // `flix-col-` and `flix-push-` grid classes doesn't follow the BEM syntax,
  // using BEM mixes in order to assemble the resulting class string
  var colClassNames = gridColBem.mix((_gridColBem$mix = {}, _defineProperty(_gridColBem$mix, gridColBem.b(), !size), _defineProperty(_gridColBem$mix, Bem("col-".concat(size), styles).b(), size), _defineProperty(_gridColBem$mix, Bem("col-".concat(sm, "-sm"), styles).b(), sm), _defineProperty(_gridColBem$mix, Bem("col-".concat(md, "-md"), styles).b(), md), _defineProperty(_gridColBem$mix, Bem("col-".concat(lg, "-lg"), styles).b(), lg), _defineProperty(_gridColBem$mix, Bem("col-".concat(xl, "-xl"), styles).b(), xl), _defineProperty(_gridColBem$mix, Bem("push-".concat(push), styles).b(), push), _defineProperty(_gridColBem$mix, Bem("push-".concat(pushSm, "-sm"), styles).b(), pushSm), _defineProperty(_gridColBem$mix, Bem("push-".concat(pushMd, "-md"), styles).b(), pushMd), _defineProperty(_gridColBem$mix, Bem("push-".concat(pushLg, "-lg"), styles).b(), pushLg), _defineProperty(_gridColBem$mix, Bem("push-".concat(pushXl, "-xl"), styles).b(), pushXl), _gridColBem$mix));
  return React.createElement("div", {
    className: colClassNames
  }, children);
};
GridCol.displayName = 'GridCol';
GridCol.defaultProps = {
  size: null,
  sm: null,
  md: null,
  lg: null,
  xl: null,
  push: null,
  pushSm: null,
  pushMd: null,
  pushLg: null,
  pushXl: null
};
GridCol.propTypes = {
  /** Children are required, no empty columns allowed, use push props instead */
  children: PropTypes.node.isRequired,

  /** Column size (from 1 to 12) for XS breakpoint and above */
  size: PropTypes.oneOfType([PropTypes.string, // @todo here and bellow deprecate "string" type
  PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])]),

  /** Column size (from 1 to 12) for SM breakpoint and above */
  sm: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])]),

  /** Column size (from 1 to 12) for MD breakpoint and above */
  md: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])]),

  /** Column size (from 1 to 12) for LG breakpoint and above */
  lg: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])]),

  /** Column size (from 1 to 12) for XL breakpoint and above */
  xl: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])]),

  /** Push columns class size (from 1 to 12) for XS breakpoint and above */
  push: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])]),

  /** Push columns class size (from 1 to 12) for SM breakpoint and above */
  pushSm: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])]),

  /** Push columns class size (from 1 to 12) for MD breakpoint and above */
  pushMd: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])]),

  /** Push columns class size (from 1 to 12) for LG breakpoint and above */
  pushLg: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])]),

  /** Push columns class size (from 1 to 12) for XL breakpoint and above */
  pushXl: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])])
};

export { GridCol };
